import { render, staticRenderFns } from "./CiPaymentInfoBox.vue?vue&type=template&id=1b269516&scoped=true&"
import script from "./CiPaymentInfoBox.vue?vue&type=script&lang=js&"
export * from "./CiPaymentInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./CiPaymentInfoBox.vue?vue&type=style&index=0&id=1b269516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b269516",
  null
  
)

component.options.__file = "CiPaymentInfoBox.vue"
export default component.exports